import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import store from '@/modules/store'

Vue.use(VueScrollTo, {
    offset: -170,
    force: true,
    cancelable: true,
    onStart: () => store.dispatch('site/setScroll', true),
    onDone: () => store.dispatch('site/setScroll', false),
    onCancel: () => store.dispatch('site/setScroll', false),
})
